export default function initBurger() {
  const burger = document.querySelectorAll('.burger');
  const menu = document.querySelector('.menu');
  const openButton = document.querySelector('.burger-open');

  burger.forEach((burgerButton) => {
    burgerButton.addEventListener('click', function () {
      itemClick(this.matches(':focus-visible'));
    });
  });

  // close menu after link clicked
  const menuLinks = document.querySelectorAll('.menu a');

  menuLinks.forEach((link) => {
    link.addEventListener('click', function () {
      itemClick(false);
    });
  });

  menu.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menu.getAttribute('aria-expanded') === 'true') {
      itemClick(true);
    }
  });

  // Only steer focus for keyboard users. A mouse/touch click shouldn't
  // pull focus onto the close/open button during normal use — that's
  // only needed so a keyboard user lands inside (or back on) the menu.
  function itemClick(moveFocus) {
    burger.forEach((burgerElement) => {
      let isExpanded = burgerElement.getAttribute('aria-expanded') === 'true';
      burgerElement.setAttribute('aria-expanded', !isExpanded);
      burgerElement.classList.toggle('open');
    });

    let isMenuExpanded = menu.getAttribute('aria-expanded') === 'true';
    menu.setAttribute('aria-hidden', isMenuExpanded);
    menu.setAttribute('aria-expanded', !isMenuExpanded);
    menu.toggleAttribute('inert', isMenuExpanded);
    menu.classList.toggle('open');

    if (moveFocus) {
      if (!isMenuExpanded) {
        menu.querySelector('.burger-close')?.focus();
      } else {
        openButton?.focus();
      }
    }
  }
}
